import React from 'react'

class MissingFile extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22" viewBox="0 0 17 22">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#F9D3D1"
            d="M.661 0H12l5 5v16.339a.661.661 0 0 1-.661.661H.66A.661.661 0 0 1 0 21.34V.66A.661.661 0 0 1 .661 0z"
          />
          <path
            fill="#E2251A"
            fillRule="nonzero"
            d="M7.472 11.533L5 9.06 6.06 8l2.473 2.472L11.005 8l1.06 1.06-2.472 2.473 2.472 2.472-1.06 1.06-2.472-2.472-2.472 2.472L5 14.005l2.472-2.472z"
          />
          <path fill="#ED7C75" d="M12 0l5 5h-4.339A.661.661 0 0 1 12 4.339V0z" />
        </g>
      </svg>
    )
  }
}

export default MissingFile
